export default __webpack_public_path__ + "static/media/2026-03-27 12.29.40.9a03b00f.jpg";